import React, { Component } from 'react';
import {
    Layout, Cascader, Drawer, Form, Breadcrumb, Input, Select, DatePicker,
    Button, TreeSelect, Table, Divider, Pagination, Modal, Popconfirm, message
} from 'antd';
import subapi from '../subapi';
const { Content } = Layout;
const FormItem = Form.Item;
const Option = Select.Option;
const { RangePicker } = DatePicker;

class operationLog extends Component {
    constructor(porps) {
        super(porps);
        this.state = {
            options: {
                page: 1,
                page_size: 10,
                pageSizeChange: this.pageChange,
                pageSizeOptions: ['10', '20', '100']
            },
            activityLog: [],
            total: []
        }
    }
    componentDidMount() {
        this.commitLog()
    }
    //分页
    pageChange = (page, page_size) => {
        console.log(page_size)
        this.setState(
            Object.assign({}, this.state, {
                options: Object.assign({}, this.state.options, {
                    page: page,
                    page_size: page_size,
                }),
            }),
        );
    };
    //操作日志列表
    commitLog() {
        let token = sessionStorage.getItem('access_token');
        let param = {
            access_token: token,
            page: this.state.options.page,
            page_size: this.state.options.page_size
        }
        subapi.commitLog(param).then(res => {
            this.setState({ activityLog: res.content.data, total: res.content })
        })
    }
    jump = () => {
        let token = sessionStorage.getItem('access_token');
        this.props.history.push(`/EditionManagement?access_token=${token}`);
    }
    formatTen(num) {
        return num > 9 ? (num + "") : ("0" + num);
    }

    formatDate = (date) => {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
    }
    mold=(data)=>{
        let list = ""
        if(data === "登录"){
            data=1
        }else if(data === "查看"){
            data=2
        }else if(data === "新建"){
            data=3
        }else if(data === "编辑"){
            data=4
        }else if(data === "删除"){
            data=5
        }
        return list
    }
    //查询
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            console.log(values)
            let start_time = '';
            let end_time = '';
            if (values.Date && values.Date.length > 0) {
                start_time = this.formatDate(new Date(values.Date[0]._d));
                end_time = this.formatDate(new Date(values.Date[1]._d));
            }
            if (!err) {
                let param = {}
                if (start_time && end_time) {
                    let token = sessionStorage.getItem('access_token'); //获取鉴权token
                    param = {
                        access_token: token,
                        page: 1,
                        page_size: this.state.options.page_size,
                        start_time: start_time,
                        end_time: end_time,
                    };
                } else {
                    let token = sessionStorage.getItem('access_token'); //获取鉴权token
                    param = {
                        access_token: token,
                        page: 1,
                        page_size: this.state.options.page_size,
                    };
                }
                for (let item in values) {
                    if (values[item]) {
                        switch (item) {
                            case 'operator':
                                param['operator'] = values[item];
                                break;
                            case 'type':
                               if(values.type !== "全部"){
                                param['state'] = values[item]==="登录"? '1':values[item]==="查看"? '2':values[item]==="新建"?'3':values[item]==="编辑"?'4':values[item]==="删除"?'5':'';
                               }
                                break;
                        }
                    }
                }
                console.log(param)
                subapi.commitLog(param).then(res => {
                    this.setState({ activityLog: res.content.data, total: res.content })
                })
                this.pageChange(1, this.state.options.page_size);
            }
        })
    }
    pagingList = (temp) => {
        console.log(temp)
        this.props.form.validateFields((err, values) => {
            console.log(values)
            let start_time = '';
            let end_time = '';
            if (values.Date && values.Date.length > 0) {
                start_time = this.formatDate(new Date(values.Date[0]._d));
                end_time = this.formatDate(new Date(values.Date[1]._d));
            }
            if (!err) {
                let param = {}
                if (start_time && end_time) {
                    let token = sessionStorage.getItem('access_token'); //获取鉴权token
                    param = {
                        access_token: token,
                        page: temp.page,
                        page_size: temp.page_size,
                        start_time: start_time,
                        end_time: end_time,
                    };
                } else {
                    let token = sessionStorage.getItem('access_token'); //获取鉴权token
                    param = {
                        access_token: token,
                        page: temp.page,
                        page_size: temp.page_size,
                    };
                }
                for (let item in values) {
                    if (values[item]) {
                        switch (item) {
                            case 'operator':
                                param['operator'] = values[item];
                                break;
                            case 'type':
                               if(values.type !== "全部"){
                                param['state'] = values[item]==="登录"? '1':values[item]==="查看"? '2':values[item]==="新建"?'3':values[item]==="编辑"?'4':values[item]==="删除"?'5':'';
                               }
                                break;
                        }
                    }
                }
                console.log(param)
                subapi.commitLog(param).then(res => {
                    this.setState({ activityLog: res.content.data, total: res.content })
                })
            }
        })
    }
    //重置
    reset = () => {
        this.props.form.resetFields([
            'operator',
            'type',
            'Date',
        ])
        this.commitLog()
    }
    render() {
        const { getFieldDecorator, resetFields } = this.props.form;
        const mold = [
            {
                key: '-1',
                value: '全部',
                title: '全部',
            },
            // {
            //     key: '1',
            //     value: '登录',
            //     title: '登录',
            // },
            {
                key: '2',
                value: '查看',
                title: '查看',
            },
            {
                key: '3',
                value: '新建',
                title: '新建',
            },
            {
                key: '4',
                value: '编辑',
                title: '编辑',
            },
            {
                key: '5',
                value: '删除',
                title: '删除',
            },
        ];
        return (
            <div style={{ width: '100%', height: 'calc(100vh - 48px)', overflowY: 'auto' }}>
                <Layout style={{ height: '100%' }}>
                    <div style={{ display: 'flex' }}>
                        <Content style={{ backgroundColor: 'rgb(242, 244, 245)', height: 'calc(100vh - 48px)', overflowY: 'auto' }}>
                            <div style={{ padding: '14px 16px', borderBottom: '1px solid rgb(204, 204, 204)', background: "#fff" }}>
                                <Breadcrumb>
                                    <Breadcrumb.Item>
                                        操作日志
                                    </Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Layout id="project_management">
                                <Content className="content">
                                    <div>
                                        <Form
                                            style={{
                                                display: 'flex',
                                                padding: '0 0rem 1rem 1rem',
                                                position: 'relative',
                                                borderBottom: '1px solid #ccc'
                                            }}
                                            layout="inline"
                                            onSubmit={this.handleSubmit}>
                                            <FormItem label="操作人">
                                                {getFieldDecorator('operator')(
                                                    <Input
                                                        onPressEnter={this.handleSubmit}
                                                        placeholder="请输入操作人"
                                                        type="text"
                                                        style={{ width: 170 }}
                                                        allowClear
                                                    />,
                                                )}
                                            </FormItem>
                                            <FormItem label="类型">
                                                {getFieldDecorator('type', {
                                                    initialValue: "全部"
                                                })(
                                                    <TreeSelect
                                                        style={{ width: 170 }}
                                                        // value={this.props.match.params.action === 'edit' ? parseInt(commodityList.cat_pid) !== 0?commodityList.cat_pid:'' : ''}
                                                        treeData={mold}
                                                        placeholder="请选择"
                                                        allowClear
                                                    />
                                                )}
                                            </FormItem>
                                            <FormItem label="发版时间">
                                                {getFieldDecorator('Date')(
                                                    <RangePicker />)}
                                            </FormItem>
                                        </Form>
                                        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px', marginTop: '20px' }}>
                                            <Button
                                                type="primary"
                                                htmlType="submit"
                                                style={{ marginRight: '1rem' }}
                                                onClick={this.handleSubmit}
                                            >
                                                搜索
                                            </Button>
                                            <Button
                                                type="default"
                                                htmlType="reset"
                                                style={{ marginRight: '1rem' }}
                                                onClick={() => {
                                                    this.reset()
                                                }}
                                            >
                                                重置
                                            </Button>
                                        </div>
                                    </div>
                                    <CustomTable
                                        activityLog={this.state.activityLog}
                                        options={this.state.options}
                                        total={this.state.total}
                                        pagingList={this.pagingList}
                                    ></CustomTable>
                                </Content>
                            </Layout>
                        </Content>
                    </div>
                </Layout>
            </div>
        )
    }
}


const OrderoperationLog = Form.create()(operationLog);
export default OrderoperationLog;

class CustomTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    componentDidMount() {

    }
    render() {
        console.log(this.props.options)
        let data = "";
        if (this.props.activityLog) {
            data = this.props.activityLog.map((item, index) => {
                let state = '';
                if (item.state == 1) {
                    state = "登录"
                } else if (item.state == 2) {
                    state = '查看'
                } else if (item.state == 3) {
                    state = '新建'
                } else if (item.state == 4) {
                    state = '编辑'
                } else if (item.state == 5) {
                    state = '删除'
                }
                return {
                    key: item.id,
                    betreiber: item.operator,
                    state: state,
                    abteilung: item.org_name,
                    beschreibung: item.describe,
                    min_version: item.create_time
                }
            })
        }
        const columns = [
            {
                title:'序号',
                render:(text,record,index)=>{
                    console.log(this.props.options.page,this.props.options.page_size)
                  //生成序号
                  return(
                    <span>{(this.props.options.page-1)*this.props.options.page_size+(index+1)}</span>
                  )
                },
                key: 'key',
                width: 100
              },
            {
                title: '操作人',
                dataIndex: 'betreiber',
                key: 'betreiber',
                width: 100
            },
            {
                title: '部门',
                dataIndex: 'abteilung',
                key: 'abteilung',
                width: 200
            },
            {
                title: '类型',
                dataIndex: 'state',
                key: 'state',
                width: 100
            },
            {
                title: '描述',
                dataIndex: 'beschreibung',
                key: 'beschreibung',

            },
            {
                title: '时间',
                dataIndex: 'min_version',
                key: 'min_version',
                width: 200
            },
        ]
        const options = {
            current: this.props.options.page,
            defaultPageSize: this.props.options.page_size,
            pageSizeOptions: this.props.options.pageSizeOptions,
            total: this.props.total.total,
            showTotal: total => `共 ${total} 条记录`,
            showSizeChanger: true,
            showQuickJumper: true,
            onChange: (page, pageSize) => {
                //console.log(page,pageSize)
                //console.log('页码改变的回调，参数是改变后的页码: ' + page + ',及每页条数: ' + pageSize);
                this.props.options.pageSizeChange(page, pageSize);
                //this.props.managementList({ current: page, pageSize: pageSize });
                //this.props.managementList(page, pageSize);
                this.props.pagingList({ page: page, page_size: pageSize })
            },
            onShowSizeChange: (current, size) => {
                // console.log('pageSize 变化的回调: ' + current + ',及每页条数: ' + size);
                this.props.options.pageSizeChange(1, size);
                //this.props.managementList({ current: 1, pageSize: size });
                //this.props.managementList(1, size)
                this.props.pagingList({ page: 1, page_size: size });
            },
        };
        return (
            <div id="mapDiv">
                <Table columns={columns} dataSource={data} scroll={{ x: 1500 }}
                    pagination={false}
                />
                <Pagination
                    style={{
                        float: 'right',
                        marginTop: '2rem',
                    }}
                    {...options}
                />
            </div>
        )
    }
}